import React from 'react'
import { Text, View, StyleSheet, Font } from '@react-pdf/renderer'

Font.register({
  family: 'Inter',
  fonts: [
    { src: `${process.env.PUBLIC_URL}/font/Inter-Regular.ttf` },
    { src: `${process.env.PUBLIC_URL}/font/Inter-Medium.ttf`, fontWeight: 500 },
    { src: `${process.env.PUBLIC_URL}/font/Inter-SemiBold.ttf`, fontWeight: 600 },
    { src: `${process.env.PUBLIC_URL}/font/Inter-Bold.ttf`, fontWeight: 700 }
  ]
})

const styles = StyleSheet.create({
  pointersContainer: {
    position: 'absolute',
    top: -6,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9999,
  },
  pointersLines: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    paddingRight: 7,
  },
  pointersText: {
    position: 'absolute',
    bottom: -3,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 10,
    backgroundColor: '#fff',
  },
  pointerRed: {
    width: '35.5%',
    height: '100%',
    borderRightWidth: 1,
    borderRightStyle: 'dotted',
    borderRightColor: 'rgb(220 38 38)',
  },
  pointerBlack: {
    width: '15%',
    height: '100%',
    borderRightWidth: 1,
    borderRightStyle: 'dotted',
    borderRightColor: '#000',
  },
  pointerGreen: {
    width: '15%',
    height: '100%',
    borderRightWidth: 1,
    borderRightStyle: 'dotted',
    borderRightColor: 'rgb(77 124 15)',
  }
});

const Pointers = ({ uiData }) => {

  const low = uiData ? uiData.scaleLow : '';
  const average = uiData ? uiData.scaleAverage : '';
  const high = uiData ? uiData.scaleHigh : '';

  return (
    <View style={styles.pointersContainer}>
      <View style={styles.pointersLines}>
        <View style={styles.pointerRed}></View>
        <View style={styles.pointerBlack}></View>
        <View style={styles.pointerGreen}></View>
      </View>
      <View style={styles.pointersText}>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: 6,
            fontWeight: 500,
            marginLeft: -8,
            color: 'rgb(220 38 38)',
          }}>{low}</Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: 6,
            fontWeight: 500,
            marginLeft: 7,
          }}>{average}</Text>
        <Text
          style={{
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: 6,
            fontWeight: 500,
            marginLeft: 5,
            color: 'rgb(77 124 15)',
          }}>{high}</Text>
      </View>
    </View>
  )
}

export default Pointers